export const updateInventoryAction = (state) => {
  return {
    type: "UPDATE_INVENTORY",
    payload: state,
  };
};
